import React from "react";
import About from "./About";
import Services from "./Services";
import Portfolio from "./Portfolio";
import Poster from "./Poster";
import Review from "./Review";
import Pricing from "./Pricing";
import Latest from "./Latest";
import Contact from "./Contact";

const Body = () => {
    return (
        <>
            <Poster />
            <About />
            <Services />
            <Portfolio />
            <Review />
            <Pricing />
            <Latest />
            <Contact />

        </>
    );
}
export default Body;